<template>
  <div class="retailCategory">
    <XR-search-head mode="category"></XR-search-head>
    <div class="nav-content">        
      <div class="nav-bar">
        <div class="fix-item top">
            <img src="images/category_bg.png" class="nav-icon" />
            <span class="shuxian"></span>
            <div class="nav-text"></div>
        </div>
        <div class="nav-list" v-for="navItem in ItemData" :key="navItem.Id">             
          <div :class="searchInfo.fatherId == navItem.Id?'item active':'item'" @click="itemClick(navItem.Id,$event)" :style="{height:cateItemHeight+'px'}">
              <img :src="navItem.IconPath" class="nav-icon" />
              <span class="shuxian"></span>
              <div class="nav-text">{{navItem.Name}}</div>
          </div>                     
        </div>            
        <div class="fix-item bottom" :style="{height:cateItemHeight+'px'}">
            <img src="images/category_bg.png" class="nav-icon" />
            <span class="shuxian"></span>
            <div class="nav-text"></div>
        </div>
      </div>
      <div class="sub-nav">
          <div class="sub-nav" v-if="show" style="display:flex;align-items:center;justify-content: center;font-size:12px;color:#999; ">
            <img src=" ../static/refresh/nomore.png" style="width:60px;" alt="">
            暂无分类项

          </div>
            <ul class="sub-nav-list" v-for="k in SubItemData" :key="k.Id">
              <li class="item">
                <template v-if="k.TypeId == '1'">
                  <div class="title" v-bind:ref="k.Id">{{k.Name}}</div>   
                </template> 
                <template v-else-if="k.TypeId == 2">
                  <div class="title" v-bind:ref="k.Id">{{k.Name}}</div>
                </template> 
                <template v-else-if="k.TypeId == 3">
                  <div class="title" v-bind:ref="k.Id">{{k.Name}}</div>
                </template> 
                <div class="content">
                  <template v-if="k.Childrens != null">
                    <template v-for="m in k.Childrens">
                      <div v-if="m.TypeId == 1" :key="m.Id">
                        <router-link class="col" :to="getUrl(m)">                    
                          <div class="img">
                            <img :src="m.IconPath?m.IconPath:''" class="sub-nav-icon" :style="{height:imgWidth+'px'}"/>
                          </div>
                          <span class="text">{{m.Name}}</span>
                        </router-link>
                      </div>
                      <div v-if="m.TypeId == 2" :key="m.Id">    
                        <router-link class="col" :to="getUrl(m)">  
                          <div class="img">
                            <img :src="m.IconPath?m.IconPath:''" class="sub-nav-icon" :style="{height:imgWidth+'px'}" />
                          </div>
                          <span class="text">{{m.Name}}</span>
                        </router-link>
                      </div>
                      <div v-if="m.TypeId == 3" :key="m.Id">    
                        <a :href="m.TypeValue" class="col">
                          <div class="img">
                            <img :src="m.IconPath?m.IconPath:''" class="sub-nav-icon" :style="{height:imgWidth+'px'}" />
                          </div>
                          <span class="text">{{m.Name}}</span>
                        </a>
                      </div>
                    </template>
                  </template>
              </div>                            
          </li>
        </ul>
      </div>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cateItemHeight: parseInt(
        document.documentElement.clientWidth * 0.3 * 0.63
      ),
      show:false,
      searchInfo:{
        fatherId:0
      },
      ItemData: [],
      SubItemData: [],
      imgWidth : 0
    };
  },
  mounted: function() {
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    var rightWidht = document.documentElement.clientWidth*0.7*0.92*0.33
    if(rightWidht){
      this.imgWidth = rightWidht
    }

    this.getList()
  },
  methods: {
    getList:function(){
    this.$refs.XRtoast.load()
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/GetShoppingCategoryNavList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.ItemData = res.Data  
          ths.searchInfo.fatherId = ths.ItemData[0].Id  
          ths.getSubList();
          ths.$refs.XRtoast.hide()
        }
      });
    },
    getSubList:function(){     
      this.$refs.XRtoast.load() 
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/GetShoppingCategoryNavList",
        JSON.stringify(this.searchInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
          ths.show = true
        }else{  
          ths.SubItemData = res.Data    
          ths.$refs.XRtoast.hide()
          
          if(ths.SubItemData.length == 0){
            ths.show = true
          }
          else{
            ths.show =false
          }
        }
      });
    },

    itemClick(fatherId){
      this.searchInfo.fatherId = fatherId
      this.getSubList()
      
    },
    getUrl(nav){
      var url = "/retail/productlist?"
      if(nav.TypeId == 1){
        url += "categoryId="+nav.TypeValue
      }
      else if(nav.TypeId == 2){
        url += "searchKey="+nav.TypeValue
      }
      return url
    }
  }
};
</script>

<style>
.retailCategory .XR-search-head {
    position: fixed;
    top: 0;
    z-index: 11;
}
.retailCategory .nav-content {
  position: absolute;
  width: 100%;
  top: 58px;
  left: 0;
  bottom: 0;
}

.retailCategory .nav-bar {
  width: 30%;
  height: 100%;
  float: left;
  background: url(/static/category_bg.png) white;
  background-size: 100% auto;
  -webkit-overflow-scrolling: touch;
}

.retailCategory .nav-bar .nav-list {
}

.retailCategory .nav-bar .nav-list .item {
  overflow: hidden;
  position: relative;
  border-bottom: 1px solid white;
}

.retailCategory .nav-bar .nav-icon {
  display: block;
  width: 100%;
}

.retailCategory .nav-bar .nav-text {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  text-align: center;
  bottom: 0;
  line-height: 100%;
  margin-top: -6px;
  color: #666;
  font-size: 14px;
}

.retailCategory .nav-bar .shuxian {
  background: red;
  width: 5%;
  position: absolute;
  top: 0;
  left: -5%;
  bottom: 0;
}

.retailCategory .nav-bar .fix-item {
  overflow: hidden;
  position: absolute;
  left: 0;
  border-bottom: 1px solid white;
  background: white;
  width: 30%;
  z-index: 999;
}
.retailCategory .XR-search-head .search-ctrl .input-ctrl{
  width: 85%;
}
.retailCategory .nav-bar .fix-item.top {
  top: 0;
  display: none;
  border: none;
}

.retailCategory .nav-bar .fix-item.bottom {
  bottom: 0;
  display: none;
  border: none;
}

.retailCategory .nav-bar .fix-item .nav-icon {
  visibility: hidden;
}

.retailCategory .nav-bar .fix-item .nav-text {
  color: #ef8569;
}

.retailCategory .nav-bar .fix-item .shuxian {
  left: 0;
}

.retailCategory .nav-bar .nav-list .item.active {
  background: white;
}

.retailCategory .nav-bar .nav-list .item.active .nav-icon {
  visibility: hidden;
}

.retailCategory .nav-bar .nav-list .item.active .nav-text {
  color: #ef8569;
}

.retailCategory .nav-bar .nav-list .item.active .shuxian {
  left: 0;
}

.retailCategory .sub-nav {
  width: 70%;
  height: 100%;
  position: fixed;
  right: 0;
  background: white;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 40px;
  -webkit-overflow-scrolling: touch;
}

.retailCategory .sub-nav .loading {
}

.retailCategory .sub-nav .loading img {
  display: block;
  margin: 40px auto 0;
}

.retailCategory .sub-nav .sub-nav-list {
  padding: 0 4%;
}

.retailCategory .sub-nav .sub-nav-list .fix-item {
  overflow: hidden;
  border-bottom: 2px solid #ddd;
  padding: 6px 0 24px;
}

.retailCategory .sub-nav .sub-nav-list .item {
  overflow: hidden;
  border-bottom: 1px solid #eee;
  padding: 6px 0 24px;
}

.retailCategory .sub-nav .sub-nav-list .item:last-child {
  border: none;
}

.retailCategory .sub-nav .sub-nav-list .item .title {
  font-size: 12px;
  line-height: 18px;
  padding: 12px 0;
  color: #999;
}

.retailCategory .sub-nav .sub-nav-list .item .content {
  overflow: hidden;
}

.retailCategory .sub-nav .sub-nav-list .item .content .col {
  width: 33%;
  float: left;
  margin: 10px 0;
}

.retailCategory .sub-nav .sub-nav-list .item .content .col .img img {
  display: block;
  margin: 0 auto;
}

.retailCategory .sub-nav .sub-nav-list .item .content .col .img .nav-loading {
}

.retailCategory .sub-nav .sub-nav-list .item .content .col .img .sub-nav-icon {
  width: 100%;
}

.retailCategory .sub-nav .sub-nav-list .item .content .col .text {
  display: block;
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-family: "黑体";
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/pages/retail/category.vue